import { Switch } from "react-router-dom";
import AcompanhamentosVistoria from "../../Pages/VistoriaEntregaDeChaves/AcompanhamentosVistoria";
import AtendimentoEntregaChaves from "../../Pages/VistoriaEntregaDeChaves/AtendimentoEntregaChaves";
import { GestaoAtendimentoVistoria } from "../../Pages/VistoriaEntregaDeChaves/GestaoAtendimentoVistoria";
import { RelatoriosBIEntregaChaves } from "../../Pages/VistoriaEntregaDeChaves/RelatoriosBI";
import { ACESSOS } from "../Acessos";
import PrivatedRoute from "../PrivatedRoute";
import HorariosDisponiveis from "../../Pages/VistoriaEntregaDeChaves/HorariosDisponiveis";
import GestaoVistoriaTabs from "../../Pages/VistoriaEntregaDeChaves/GestaoVistoriaTabs";
import AgendaAtividadesComponent from "../../Pages/Geral/Agenda/Agenda";
import PesquisaSatisfacaoVistoria from "../../Pages/VistoriaEntregaDeChaves/PesquisaSatisfacaoVistoria/PesquisaSatisfacaoVistoria";

export default function RotasEntregaDeChaves() {
    return (
        <Switch>
            <PrivatedRoute
                path={
                    ACESSOS.ENTREGA_DE_CHAVES.TELAS.ATENDIMENTOS.TODOS.DS_PATH
                }
                component={GestaoAtendimentoVistoria.TodosAtendimentosVistoria}
                isPrivate
                idModulo={ACESSOS.ENTREGA_DE_CHAVES.ID_MODULO}
                idTela={
                    ACESSOS.ENTREGA_DE_CHAVES.TELAS.ATENDIMENTOS.TODOS.ID_TELA
                }
            />
            <PrivatedRoute
                path={ACESSOS.ENTREGA_DE_CHAVES.TELAS.GESTAO_VISTORIA.DS_PATH}
                component={GestaoVistoriaTabs}
                isPrivate
                idModulo={ACESSOS.ENTREGA_DE_CHAVES.ID_MODULO}
                idTela={ACESSOS.ENTREGA_DE_CHAVES.TELAS.GESTAO_VISTORIA.ID_TELA}
            />
            <PrivatedRoute
                path={
                    ACESSOS.ENTREGA_DE_CHAVES.TELAS.ATENDIMENTOS
                        .MEUS_ATENDIMENTOS.DS_PATH
                }
                component={GestaoAtendimentoVistoria.MeusAtendimentosVistorias}
                isPrivate
                idModulo={ACESSOS.ENTREGA_DE_CHAVES.ID_MODULO}
                idTela={
                    ACESSOS.ENTREGA_DE_CHAVES.TELAS.ATENDIMENTOS
                        .MEUS_ATENDIMENTOS.USUARIO.ID_TELA
                }
            />
            <PrivatedRoute
                path={
                    ACESSOS.ENTREGA_DE_CHAVES.TELAS.ATENDIMENTOS.GRUPO.DS_PATH
                }
                component={GestaoAtendimentoVistoria.FilaAtendimentoVistoria}
                isPrivate
                idModulo={ACESSOS.ENTREGA_DE_CHAVES.ID_MODULO}
                idTela={
                    ACESSOS.ENTREGA_DE_CHAVES.TELAS.ATENDIMENTOS.GRUPO.ID_TELA
                }
            />
            <PrivatedRoute
                path={ACESSOS.ENTREGA_DE_CHAVES.TELAS.ATENDIMENTO.DS_PATH}
                component={AtendimentoEntregaChaves}
                isPrivate
                idModulo={ACESSOS.ENTREGA_DE_CHAVES.ID_MODULO}
                idTela={ACESSOS.ENTREGA_DE_CHAVES.TELAS.ATENDIMENTO.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.ENTREGA_DE_CHAVES.TELAS.CAPYS_BI.DS_PATH}
                component={RelatoriosBIEntregaChaves}
                isPrivate
                idModulo={ACESSOS.ENTREGA_DE_CHAVES.ID_MODULO}
                idTela={ACESSOS.ENTREGA_DE_CHAVES.TELAS.CAPYS_BI.ID_TELA}
            />
            <PrivatedRoute
                path={
                    ACESSOS.ENTREGA_DE_CHAVES.TELAS.GESTAO_CADASTRO
                        .HORARIOS_DISPONIVEIS.DS_PATH
                }
                component={HorariosDisponiveis}
                isPrivate
                idModulo={ACESSOS.ENTREGA_DE_CHAVES.ID_MODULO}
                idTela={
                    ACESSOS.ENTREGA_DE_CHAVES.TELAS.GESTAO_CADASTRO
                        .HORARIOS_DISPONIVEIS.ID_TELA
                }
            />
            <PrivatedRoute
                path={
                    ACESSOS.ENTREGA_DE_CHAVES.TELAS.ACOMPANHAMENTOS_VISTORIA
                        .DS_PATH
                }
                component={AcompanhamentosVistoria}
                isPrivate
                idModulo={ACESSOS.ENTREGA_DE_CHAVES.ID_MODULO}
                idTela={
                    ACESSOS.ENTREGA_DE_CHAVES.TELAS.ACOMPANHAMENTOS_VISTORIA
                        .ID_TELA
                }
            />

            <PrivatedRoute
                path={ACESSOS.ENTREGA_DE_CHAVES.TELAS.GESTAO_ATIVIDADES.DS_PATH}
                component={AgendaAtividadesComponent}
                isPrivate
                idModulo={ACESSOS.ENTREGA_DE_CHAVES.ID_MODULO}
                idTela={
                    ACESSOS.ENTREGA_DE_CHAVES.TELAS.GESTAO_ATIVIDADES.ID_TELA
                }
            />

            <PrivatedRoute
                path={
                    ACESSOS.ENTREGA_DE_CHAVES.TELAS.PESQUISA_SATISFACAO.DS_PATH
                }
                component={PesquisaSatisfacaoVistoria}
                isPrivate
                idModulo={ACESSOS.ENTREGA_DE_CHAVES.ID_MODULO}
                idTela={
                    ACESSOS.ENTREGA_DE_CHAVES.TELAS.PESQUISA_SATISFACAO.ID_TELA
                }
            />
        </Switch>
    );
}
